import _ from 'lodash'
import {
    CLIENT_LAUNCHER_SET_TOKEN,
    CLIENT_LAUNCHER_SET_EULA,
    CLIENT_LAUNCHER_RESET,
} from '../constants'

const initialState = {}

export default function clientLauncher(state = initialState, action) {
    switch (action.type) {
        // Update the state of launcher readiness
        case CLIENT_LAUNCHER_SET_TOKEN: {
            const { userId, serverId, profile, token } = action.payload
            let current = state[userId]
            if (!current) {
                current = {
                    eulaReady: false,
                    eualaOk: false,
                }
            }
            current.serverId = serverId
            current.profile = profile
            current.token = token
            current.tokenReady = true
            return {
                ...state,
                [userId]: { ...current },
            }
        }

        case CLIENT_LAUNCHER_SET_EULA: {
            const { userId, eulaOk } = action.payload
            let current = state[userId]
            if (!current) {
                current = {
                    serverId: undefined,
                    profile: undefined,
                    token: undefined,
                    tokenReady: false,
                }
            }
            current.eulaReady = true
            current.eulaOk = eulaOk
            return {
                ...state,
                [userId]: { ...current },
            }
        }

        case CLIENT_LAUNCHER_RESET: {
            const userId = action.payload
            if (!state[userId]) {
                return state
            }

            return _.omit(state, userId)
        }

        default:
            return state
    }
}

export const getClientData = (state, userId) => {
    if (state.clientLauncher[userId]) {
        return { ...state.clientLauncher[userId] }
    }

    return undefined
}



// WEBPACK FOOTER //
// ./src/reducers/clientLauncher.js